import PlaceholderImage from '@assets/images/segmentacoes01.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SegmentationOne.style';
import { useTranslation } from 'react-i18next';

const SegmentationOne = () => {
  const { t } = useTranslation('segmentation');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('segmentationOne.title.spanBefore')}
          <span>2</span> {t('segmentationOne.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <p>
            {t('segmentationOne.paragraphOne')}
            <br />
            <br /> {t('segmentationOne.paragraphTwo.spanBefore')}
            <span>2</span> {t('segmentationOne.paragraphTwo.spanAfter')}
            <br />
            <br />
            {t('segmentationOne.paragraphThree')}
          </p>
        </TextBox2>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SegmentationOne;
